(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("blockstack"));
	else if(typeof define === 'function' && define.amd)
		define(["blockstack"], factory);
	else if(typeof exports === 'object')
		exports["blockstackCollections"] = factory(require("blockstack"));
	else
		root["blockstackCollections"] = factory(root["blockstack"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 